import { Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppState } from '../app.service';
import { CordovaService } from '../cordova.service';
import { RoutineInfo } from './routine-info.model';
import { RoutineLevel } from './routine-level.model';
import { HomeUiService } from '../../app/new-design/home-ui.service';
import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'first90-routine-sublevel',
  templateUrl: './routine-sublevel.component.html',
  styleUrls: ['./routine-sublevel.component.scss'],
  animations: [
    trigger('popupAnimation', [
      state('void', style({ opacity: 0, transform: 'scale(0.9)' })),
      state('*', style({ opacity: 1, transform: 'scale(1)' })),
      transition('void <=> *', animate('300ms ease-in-out')),
    ]),
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),
  
        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),
  
      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]
  
})
export class RoutineSubLevelComponent implements OnInit, DoCheck {

  @Input() routines
  @Input() levels
  @Input() inverted = false
  levelCount: number
  selectedLevels: any
  indexOfLevel: number
  totalLevels: number=0;
  isPopupVisible: boolean = false;
  isMobile = false;
  isMobileWeb = false
  isMobileWebIos = false;
  @Input() progressItems = []
  @Input() currentIndex = 0
  @Input() screenId;
  constructor(private cordovaService: CordovaService,
    public homeUIService: HomeUiService,
    public appState: AppState) {
     }

  ngOnInit() {
     this.isMobile = this.appState.get('isMobile')
      this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
  }

  ngDoCheck(){
    this.selectedLevels = this.appState.get('selectedLevelIds')
    this.indexOfLevel = this.appState.get('indexOfLevel')
    this.levelCount = this.selectedLevels?.findIndex(item => item?.id === this.levels?.id)
    // if (!this.appState.get('levelUpdated')) {
    //   this.levelCount = 1
    //   this.totalLevels = this.routines?.screen?.content?.habits?.length
    // }else {
    if (!this.appState.get('levelUpdated') && this.levelCount != this.selectedLevels?.[this.levelCount]?.index) {
        this.levelCount = this.levelCount+1
    }
    else {
      if (this.indexOfLevel != undefined) {
        this.levelCount = this.indexOfLevel + 1
      }
      else {
         this.levelCount = this.levelCount+1
      }
      if (this.selectedLevels?.length > 0) {
        this.totalLevels = this.selectedLevels?.length;
      }
      else {
         this.totalLevels = this.routines?.screen?.userResponse?.selectedHabitIds?.length?? this.routines?.screen?.content?.habits?.length
      }
     
    }
   // }
    if(this.levels && this.levels.enabled==false )
    {
      let flag =false
        this.routines?.screen?.content?.habits?.forEach((level,index)=>{
          if((level.enabled ||level.enabled ==undefined) && !flag && level.level == this.appState.get('LevelNumber')) {
            this.levels =level
            this.appState.set('indexOfLevel', index) 
            flag =true;
          }
        })
    }
  }

  openPopup() {
    this.isPopupVisible = !this.isPopupVisible;
  }
  closePopup() {
    this.isPopupVisible = false;
  }
}
